// Copyright (c) Meta Platforms, Inc. and affiliates.
// All rights reserved.

// This source code is licensed under the license found in the
// LICENSE file in the root directory of this source tree.

export interface modelScaleProps {
  samScale: number;
  height: number;
  width: number;
}

export interface modelInputProps {
  x: number;
  y: number;
  clickType: number;
}

export interface modeDataProps {
  clicks?: Array<modelInputProps>;
  modelScale: modelScaleProps;
}

export interface ToolProps {
  handleMouseMove: (e: any) => void;

  // setImageMaskState: (state: ImageMaskState) => void;
}

export interface RGBAColors {
  r: number;
  g: number;
  b: number;
  a: number;
}

export enum ImageMaskState {
  Loading,
  Loaded,
  Replace,
  ReplaceFormLoaded,
  Select,
  Deselect,
  Erase,
  Selected,
  Deselected,
  Erasing,
  Replacing,
  Enhance,
  Enhancing,
  Done,
  Error,
  Cancel,
  Inspire,
  Inspiring,
}

export interface AlertProps {
  alertType: string,
  alertContent: string
}

